import { actions, selectors, useDispatch, useSelector } from '@sloyd/store-base';
import { useMemo } from 'react';
import { ContentSettings } from './ContentSettings';

export type ContentSettingsContainerProps = {};

export function ContentSettingsContainer(_props: ContentSettingsContainerProps) {
  const dispatch = useDispatch();
  const settings = useSelector(selectors.raw.$rawSettings);

  const callbacks = useMemo(
    () => ({
      onChange: (_change: Json, allData: Json) => {
        dispatch(actions.settings.patch(allData));
      },
    }),
    []
  );

  return <ContentSettings settings={settings} callbacks={callbacks} />;
}

export default ContentSettingsContainer;
